/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I paste binary without spaces?`)
};

const es_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo pegar binario sin espacios?`)
};

const de_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Binärcode ohne Leerzeichen einfügen?`)
};

const nl_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik binair zonder spaties plakken?`)
};

const fr_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je coller du binaire sans espaces?`)
};

const it_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso incollare il binario senza spazi?`)
};

const pt_br2_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso colar binário sem espaços?`)
};

const pt_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso colar binário sem espaços?`)
};

const ja_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペースなしでバイナリを貼り付けることができますか?`)
};

const zh_tb_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以粘贴没有空格的二进制吗?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq2_q", locale)
	if (locale === "en") return en_tb_faq2_q(inputs)
	if (locale === "es") return es_tb_faq2_q(inputs)
	if (locale === "de") return de_tb_faq2_q(inputs)
	if (locale === "nl") return nl_tb_faq2_q(inputs)
	if (locale === "fr") return fr_tb_faq2_q(inputs)
	if (locale === "it") return it_tb_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq2_q(inputs)
	if (locale === "pt") return pt_tb_faq2_q(inputs)
	if (locale === "ja") return ja_tb_faq2_q(inputs)
	return zh_tb_faq2_q(inputs)
};